import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';

import Screenshot from './Screenshot.png';
import './Home.css';

function Home() {
  return (
    <>
      <Row className="text-center mt-5">
        <Col>
          <img src={Screenshot} className="App-logo" alt="screenshot" />
        </Col>
      </Row>
      <Row className="text-center mt-5">
        <Col>
          <Card>
            <Card.Title>Features</Card.Title>
            <Card.Body>
              <ListGroup>
                <ListGroup.Item>Select the active slot</ListGroup.Item>
                <ListGroup.Item>Configure virtualized card type for each slot</ListGroup.Item>
                <ListGroup.Item>Upload binary card images from your phone, or download from your Chameleon to your phone!</ListGroup.Item>
                <ListGroup.Item>Download detection log file and use an online version of mfkey32v2 to recover Mifare Classic keys</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Home;
